module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp3_8023.4ff2467e.png";